import { render, staticRenderFns } from "./ExtendedLink.vue?vue&type=template&id=4a20cda5&"
import script from "./ExtendedLink.vue?vue&type=script&lang=js&"
export * from "./ExtendedLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports